export enum BiometriaStatusEnum {
  Capturando = 'capturando',
  Sucesso = 'sucesso',
  Erro = 'erro',
}